import React from 'react'
import Loadable from 'react-loadable'
import Loading from '../../components/loader/Loader'
import RolesEnum from '../../Enum/RolesEnum';

const RelatorioMotoristasComponent = Loadable({
  loader: () => import('../../../pages/relatorio/motorista/RelatorioMotoristas'),
  loading: () => <Loading />
})

const RelatorioRevendasComponent = Loadable({
  loader: () => import('../../../pages/relatorio/revenda/RelatorioRevendas'),
  loading: () => <Loading />
})

const RelatorioPedidosComponent = Loadable({
  loader: () => import('../../../pages/relatorio/pedidos/RelatorioPedidos'),
  loading: () => <Loading />
})

export default [
  {
    path: '/relatorios/motoristas',
    title: 'Relatorios',
    component: RelatorioMotoristasComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas]
  },
  {
    path: '/relatorios/revendas',
    title: 'Relatorios',
    component: RelatorioRevendasComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas]
  },
  {
    path: '/relatorios/pedidos',
    title: 'Relatorios',
    component: RelatorioPedidosComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  }
]
